import { Button, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, Save } from 'react-feather'

export const DefaultFinishStep = (props) => {
    const {handleClickReturnStep, onSubmitChangeApprovalStep} = props
    return (
        <div className='text-center'>
            <Typography variant="h5" gutterBottom>
                Confirmación de procedimiento.
            </Typography>
            <p> 
                Todos los pasos se han cumplido, 
                haga click en el botón de "Finalizar procedimiento" para volver a la pantalla de solicitudes,
                o "Volver a revisar" para volver a al paso anterior
            </p>
            <div className="border-bottom border-secondary m-3"></div>
            <div className="text-center">
                <Button
                    startIcon={<ArrowLeftCircle/>}
                    variant="contained"
                    type="button"
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                >
                    Volver
                </Button>
                <Button
                    endIcon={<Save/>}
                    variant="contained"
                    type='button'
                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                    onClick={onSubmitChangeApprovalStep}
                >
                    Finalizar procedimiento
                </Button>
            </div>
        </div>
    )
}
